/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Typography } from "@mui/material";
import Container from "@/src/components/Container/Container";
import React from "react";
import Section from "@/src/components/Section/Section";

export default function ValueProposition() {
  return (
    <Section component={"div"}>
      <Container variant={"md"} showPaddingBlock={false}>
        <Typography component={"p"} variant={"h3"} align={"center"}>
          Wir stehen Ihnen mit jahrelanger anwaltlicher Expertise und modernster Technologie zu Seite. Sie behalten jederzeit den Überblick und werden
          professionell und persönlich von uns begleitet.
        </Typography>
      </Container>
    </Section>
  );
}
